export default () => 'Progress – Conjugr8'
